




































































































































































import { Component, Prop } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxLookup
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Crane } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';
import { ResourceTypeTree, Site, ActivitySchedule } from '@/dto';
import TreeDropDown from '@/core/components/controls/TreeDropDown.vue';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxCustomRule,
        TreeDropDown,
        DxLookup
    }
})
export default class CranesListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: true }) public resourceTypes!: any[];
    @Prop({ type: Array, required: true }) public sites!: Site[];
    @Prop({ type: Array, required: true }) public activityShedules!: ActivitySchedule[];

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this)
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public initRow(e: any) {
        e.data.allowedWaiting = e.data.allowedWaiting !== null
                                        && e.data.allowedWaiting !== undefined
                                        ? e.data.allowedWaiting : '00:00:00';
        e.data.preferredOperationType = e.data.preferredOperationType === 'load'
                                        || e.data.preferredOperationType === 'unload'
                                        ? e.data.preferredOperationType : null;
        e.data.isActive = e.data.isActive !== null && e.data.isActive !== undefined
                                      ? e.data.isActive : true;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    private get localizePlaceholder() {
        return localize('PlaceholderAny');
    }

    private get treeDropDown(): TreeDropDown {
        const name = 'tree-drop-down';
        return this.$refs[name] as TreeDropDown;
    }

    private get preferredOperationsDataSource(): any {
        return [
            {
                name: localize('CranePrefferedOperation_NotSelected'),
                value: null
            },
            {
                name: localize('CranePrefferedOperation_Load'),
                value: 'load'
            },
            {
                name: localize('CranePrefferedOperation_Unload'),
                value: 'unload'
            }
        ];
    }

    public deleteCrane() {
        this._windowsService!.showDialog(
            localize('CraneSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        ).then(id => {
            if (id === 1) {
                const crane = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    Cranes_Partial: [
                        {
                            id: crane.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<Crane>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }

    private validateDropDown() {
        return this.treeDropDown ? this.treeDropDown.validateInput() : null;
    }

    private getloadHandler(): (parameters: any) => Promise<any[]> {
        return (parameters: any) => {
            return this.load(parameters);
        };
    }

    private async load(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        const parentId = parameters && parameters.filter ? parameters.filter[1] : '';
        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        return await this._fetchService!.get<ResourceTypeTree[]>(url);
    }

    private getloadSelectedItemsHandler(): (items: any) => Promise<any[]> {
        return (items: any) => {
            return this.loadSelectedItems(items);
        };
    }

    private async loadSelectedItems(items: any) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/resourceTypesList/selected/${items}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);

        return data;
    }

    private itemsArrayToString(items: any) {
        if (!items || items === null) {
            return '';
        }
        return typeof items === 'string' ? items : items.join(',');
    }
}
